/**
 * @ComponentFor Avensia.Scope.ServerRenderedHtmlBlock
 */
import React from "react";
function ServerRenderedHtmlBlock(props) {
    console.log(props);
    return (React.createElement("div", { dangerouslySetInnerHTML: { __html: props.htmlString } }));
}
export default ServerRenderedHtmlBlock;
